module.exports = __webpack_public_path__ + "nc_static/media/authFailed.de8b376c.png";